
import scrolling from './scrolling';

const domUtils = {

    scrolling,

}

export default domUtils;